<div class="access-denied-container">
  <div class="access-denied-content">
    <div class="icon-wrapper">
      <i class="fas fa-lock"></i>
    </div>
    <h1 class="title">Access Restricted</h1>
    <p class="message">
      You do not have permission to access this module or perform this action.
    </p>
    <p class="role-info">
      Your current role: <strong>{{ userRole }}</strong>
    </p>
    <p class="help-text">
      If you believe this is an error, please contact your system administrator.
    </p>
    <button class="btn btn-primary" (click)="goToHome()">
      <i class="fas fa-home me-2"></i>Go to Home
    </button>
  </div>
</div>
